<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>租赁管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 搜索 -->
    <el-card shadow="hover">
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城    市">
          <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" style="width:120px" filterable
                     @change="cityChange">
            <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName"
                       :value="item.id+''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="服务站">
          <el-select v-model="listQuery.stationId" clearable placeholder="请选择服务站" filterable>
            <el-option v-for="(item,index) in stationList" :key="index" :label="item.stationName"
                       :value="item.id+''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="租赁状态">
          <el-select v-model="listQuery.status" clearable placeholder="请选择租赁状态" filterable>
            <el-option v-for="(item,index) in statusList" :key="index" :label="item.text" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="租赁编号">
          <el-input v-model="listQuery.leaseNo" placeholder="请输入租赁编号" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="租赁日期">
          <el-date-picker v-model="arrayTime" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
                          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="{}"></el-date-picker>
        </el-form-item>

        <el-form-item label="租赁人">
          <el-input v-model="listQuery.rentAccountName" style="width:150px" placeholder="请输入租赁人"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="租赁人手机">
          <el-input v-model="listQuery.rentAccountPhone" placeholder="请输入租赁人手机" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>
        <br/>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <!-- <el-tabs style="margin-left:5px">
              <el-tab-pane label="租赁单明细数据"></el-tab-pane>
            </el-tabs> -->
            <div class="marker">租赁单明细数据</div>
            <el-table :data="scope.row.details" border class="table" max-height="320">
              <el-table-column prop="skuName" label="商品"></el-table-column>
              <el-table-column prop="snCode" label="SN码"></el-table-column>
              <el-table-column prop="deposit" label="押金" width="80"></el-table-column>
              <el-table-column prop="rent" label="租金" width="80"></el-table-column>
              <el-table-column prop="status" label="租赁状态">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status!=1?'success':''">
                    {{ scope.row.status == 1 ? '租赁中' : (scope.row.status == 2 ? "已归还" : "待租赁") }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="returnTime" label="归还日期"></el-table-column>
              <el-table-column prop="returnAmount" label="退还金额"></el-table-column>
              <el-table-column prop="alreadyLeaseDays" label="该SN总已租赁天数"></el-table-column>
              <el-table-column prop="goodStatus" label="商品状态">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.goodStatus!=1?'success':''" v-if="scope.row.goodStatus">
                    {{ scope.row.goodStatus|goodsStatusFilter }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="returnGoodsVoucher" label="商品照片">
                <template slot-scope="scope">
                  <div style="display:flex">
                    <span v-if="scope.row.files==''">无</span>
                    <el-image v-else slot="reference" class="el-image"
                              :preview-src-list="scope.row.returnGoodsVoucher.split(',')"
                              v-for="item in scope.row.returnGoodsVoucher.split(',')" :key="item.index"
                              :src="item"></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="fineType" label="罚款类型">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.fineType!=1?'success':''" v-if="scope.row.fineType">
                    {{ scope.row.fineType|fineTypeFilter }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="fine" label="罚款金额"></el-table-column>
              <el-table-column prop label="操作" fixed="right" width="100px" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleLeaseReturnEdit(scope.row)" size="mini"
                             v-if="scope.row.status!=2" icon="el-icon-refresh-left" v-per="'leaseReturn'">归还
                  </el-button>
                </template>
              </el-table-column>

            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="leaseNo" label="租赁单号" width="180"></el-table-column>
        <el-table-column prop="workNo" label="商家编号" ></el-table-column>
        <el-table-column prop="rentAccountName" label="租赁人"></el-table-column>
        <el-table-column prop="rentAccountPhone" label="租赁人电话"></el-table-column>
        <el-table-column prop="rentStartTime" :formatter="dateFormatA" label="租赁时间" width="170">
          <template slot-scope="scope">
            开始：{{ formateDay(scope.row.rentStartTime) }}<br/> 截至：{{ formateDay(scope.row.rentEndTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status!=1?'success':''">
              {{ scope.row.status | statusFilter }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="deposit" label="押金"></el-table-column>
        <el-table-column prop="rent" label="租金"></el-table-column>
        <el-table-column prop="returnAmount" label="退还金额"></el-table-column>
        <el-table-column prop="createTime" label="申请租赁时间" :formatter="dateFormatA"
                         width="140px"></el-table-column>
        <el-table-column prop="updateTime" label="最后处理时间"></el-table-column>
        <el-table-column prop="updateUserName" label="最后处理人"></el-table-column>

        <!-- <el-table-column prop label="操作" fixed="right" width="120px" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleLeaseReturn(scope.row)" size="mini" v-if="scope.row.status!=3&&scope.row.status!=6" icon="el-icon-refresh-left">归还</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <pagination :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
                  @pagination="querySearch"/>
    </el-card>

    <!-- 租赁详情 -->
    <el-dialog title="租赁商品归还" :visible.sync="leaseDetailListVisible" width="1180px" :close-on-click-modal="false"
               center>

      <div v-if="leaseDetailVisible">
        <el-form class="demo-form-inline" :inline='true' :model="leaseDetail" :rules="rules" ref="leaseDetail"
                 label-width="80px">
          <div class="font-small">{{ leaseDetail.skuName }} 租赁归还基本信息</div>
          <div class="table-layout">
            <el-row>
              <el-col :span="4" class="table-cell-title">商品名称</el-col>
              <el-col :span="4" class="table-cell-title">商品SN码</el-col>
              <el-col :span="4" class="table-cell-title">已收押金</el-col>
              <el-col :span="4" class="table-cell-title">已收租金</el-col>
              <el-col :span="4" class="table-cell-title">原定租期</el-col>
              <el-col :span="4" class="table-cell-title">每日租金</el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="table-cell">{{ leaseDetail.skuName }}</el-col>
              <el-col :span="4" class="table-cell">{{ leaseDetail.snCode }}</el-col>
              <el-col :span="4" class="table-cell">{{ leaseDetail.deposit }}</el-col>
              <el-col :span="4" class="table-cell">{{ leaseDetail.rent }}</el-col>
              <el-col :span="4" class="table-cell">
                {{ leaseDetail.rentStartTime }}<br/>{{ leaseDetail.rentEndTime }}<br/>共{{ leaseDetail.totalDay }}天
              </el-col>
              <el-col :span="4" class="table-cell">{{ leaseDetail.rentDay }}</el-col>
            </el-row>
          </div>
          <div class="font-small">{{ leaseDetail.skuName }} 归还信息编辑</div>
          <el-form-item label="归还日期" prop="returnTime">
            <el-date-picker v-model="leaseDetail.returnTime" type="datetime" style="width:185px"
                            @change="returnTimeChange" placeholder="请选择归还日期" :picker-options="{}">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="使用天数" prop="days">
            <el-tag style="width:185px">实际使用{{ leaseDetail.days }}天</el-tag>
          </el-form-item>

          <el-form-item label="物品状态" prop="goodStatus">
            <el-select v-model="leaseDetail.goodStatus" style="width:185px">
              <el-option v-for="(item,index) in goodsStatusList" :key="index" :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="罚款类型" prop="fineType">
            <el-select v-model="leaseDetail.fineType" style="width:185px" clearable="">
              <el-option v-for="(item,index) in fineType" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <br/>

          <el-form-item label="应收租金" prop="arRent">
            <el-tag type='success' style="width:185px">￥{{ leaseDetail.arRent }}元</el-tag>
            <!-- <el-input v-model="leaseDetail.arRent" style="width:185px" type="number" disabled placeholder="请输入应收租金">
            </el-input> -->
          </el-form-item>

          <el-form-item label="罚款金额" prop="fine">
            <el-input v-model="leaseDetail.fine" style="width:185px" @change="fineChange" type="number"
                      placeholder="请输入罚款金额"></el-input>
          </el-form-item>

          <el-form-item label="应退金额" prop="returnAmount">
            <el-input v-model="leaseDetail.returnAmount" style="width:185px" type="number"
                      placeholder="请输入归还金额"></el-input>
          </el-form-item>

          <br/>
          <p style="margin:-20px 0 10px 12px;color:red;font-size:12px;">应收租金金额仅供参考,以实际收款金额为准</p>
          <div class="adv-img">
            <el-form-item label="物品图片" prop="returnGoodsVoucher">
              <el-upload :action="addFile" :limit="5" :on-exceed="uploadOverrun" :on-success="handleGalleryUrl"
                         :on-remove="handleRemove" multiple accept=".jpg,.jpeg,.png,.gif" list-type="picture-card">
                <i class="el-icon-plus"/>
              </el-upload>
            </el-form-item>
          </div>
          <br/>
          <el-form-item label="归还备注" prop="remark">
            <el-input v-model="leaseDetail.remark" style="width:800px" placeholder="请输入备注"></el-input>
          </el-form-item>
          <!-- <el-button type="info" @click="leaseReturnConfirm">归还信息确认</el-button> -->
        </el-form>

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="leaseReturnSubmit">归还</el-button>
      </span>
    </el-dialog>

  </div>

</template>


<script>
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import Service from "@/script/api/service";
import date from "@/script/api/date";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
import addFile from "@/script/api/storage";

let vm;
export default {
  components: {Pagination},
  filters: {
    statusFilter(value) {
      const rs = vm.statusList.filter((item) => {
        return item.id === value;
      });

      if (rs != null && rs.length > 0) {
        return rs[0].text;
      }
    },
    cityFilter(value) {
      const rs = vm.cityList.filter((item) => {
        return item.id == value;
      });
      if (rs != null && rs.length > 0) {
        return rs[0].cityName;
      }
    },
    fineTypeFilter(value) {
      const rs = vm.fineType.filter((item) => {
        return item.id === value;
      });

      if (rs != null && rs.length > 0) {
        return rs[0].name;
      }
    },
    goodsStatusFilter(value) {
      const rs = vm.goodsStatusList.filter((item) => {
        return item.id === value;
      });

      if (rs != null && rs.length > 0) {
        return rs[0].name;
      }
    },
  },
  data() {
    return {
      addFile: Service.addFile + globalData.userInfo.userAccount,
      cityList: [],
      stationList: [],
      listData: [],
      arrayTime: [],
      total: 0,
      listQuery: {
        rentAccountName: "",
        rentAccountPhone: "",
        stationId: "",
        status: "",
        cityId: "",
        pageNum: 1,
        pageSize: 10,
      },
      statusList: [
        {id: 1, text: "待发放"},
        {id: 2, text: "租赁中"},
        {id: 3, text: "已归还"},
        {id: 4, text: "未归还"},
        {id: 5, text: "部分归还"},
        {id: 6, text: "已取消"},
      ],
      fineType: [
        {id: 1, name: "超期归还"},
        {id: 2, name: "归还物品损坏"},
        {id: 3, name: "物品丢失"},
        {id: 4, name: "超期+物品损坏"},
      ],
      goodsStatusList: [
        {id: 1, name: "正常"},
        {id: 2, name: "损坏"},
        {id: 3, name: "丢失"},
        {id: 4, name: "报废"},
      ],
      leaseDetailListVisible: false,
      leaseDetailList: [],
      leaseDetail: {}, //当前编辑的lease
      leaseDetailVisible: false,
      rules: {
        returnTime: [
          {required: true, message: "归还时间不能为空", trigger: "blur"},
        ],
        goodStatus: [
          {required: true, message: "物品状态不能为空", trigger: "blur"},
        ],
        arRent: [
          {required: true, message: "应收租金不能为空", trigger: "blur"},
        ],
        returnAmount: [
          {required: true, message: "退还金额不能为空", trigger: "blur"},
        ],
      },
    };
  },
  beforeCreate() {
    vm = this;
  },
  created() {
    this.getAllStationList();
    this.querySearch();
  },
  methods: {
    //查询
    querySearch() {
      if (this.arrayTime.length > 0) {
        this.listQuery.createTimeStart = this.arrayTime[0];
        this.listQuery.createTimeEnd = this.arrayTime[0];
      } else {
        this.listQuery.createTimeStart = null;
        this.listQuery.createTimeEnd = null;
      }
      console.info(this.listQuery);
      wmsApi
        .$axiosOrderLeaseList(this.listQuery)
        .then((res) => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllStationList() {
      wmsApi
        .$axiosCityStationGetAll({})
        .then((res) => {
          this.cityList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cityChange(value) {
      console.info(value);
      let currentStation = this.cityList.filter((item) => {
        return item.id == value;
      });

      console.info(currentStation);
      this.stationList = currentStation[0].stationList;
    },
    handleLeaseReturn(row) {
      this.leaseDetailList = row.details;
      this.leaseDetailListVisible = true;
    },
    handleLeaseReturnEdit(row) {
      this.leaseDetail = JSON.parse(JSON.stringify(row));
      this.leaseDetail.returnGoodsVoucher = [];
      this.leaseDetail.fine = 0;
      this.leaseDetail.returnTime = new Date(
        new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
      ); //new Date();
      this.leaseDetail.days = date.difference(
        this.leaseDetail.rentStartTime,
        this.leaseDetail.returnTime
      );
      //原租期天数
      this.leaseDetail.totalDay = date.difference(
        this.leaseDetail.rentStartTime,
        this.leaseDetail.rentEndTime
      );
      //计算每日预计租金
      this.leaseDetail.rentDay = (
        this.leaseDetail.rent / this.leaseDetail.totalDay
      ).toFixed(2);
      //应收租金
      this.leaseDetail.arRent =
        this.leaseDetail.days * this.leaseDetail.rentDay;
      if (this.leaseDetail.arRent < 0) {
        this.leaseDetail.arRent = 0;
      }
      this.leaseDetailListVisible = true;
      this.leaseDetailVisible = true;
      //应退金额=已收押金+已收租金-应收租金-罚款
      this.leaseDetail.returnAmount =
        this.leaseDetail.deposit +
        this.leaseDetail.rent -
        this.leaseDetail.arRent -
        this.leaseDetail.fine;
    },
    leaseReturnSubmit() {
      //归还内容确认
      this.$refs["leaseDetail"].validate((valid) => {
        if (valid) {
          //物品图片
          let voucher = "";
          if (this.leaseDetail.returnGoodsVoucher.length > 0) {
            this.leaseDetail.returnGoodsVoucher.forEach((item, index) => {
              voucher += item;
              if (index != this.leaseDetail.returnGoodsVoucher.length - 1)
                voucher += ",";
            });
          }
          //封装参数
          let params = {
            leaseNo: this.leaseDetail.leaseNo,
            returnType: 1,
            snList: [
              {
                fine: this.leaseDetail.fine,
                fineType: this.leaseDetail.fineType,
                goodStatus: this.leaseDetail.goodStatus,
                returnGoodsVoucher: voucher,
                returnTime: this.leaseDetail.returnTime,
                snCode: this.leaseDetail.snCode,
                remark: this.leaseDetail.remark,
              },
            ],
          };
          console.info(params)
          this.$confirm("确定归还此商品吗?请仔细核对金额后点击确认。", "提示", {
            confirmButtonText: "归还",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            wmsApi.$axiosOrderLeaseReturn(params).then((res) => {
              this.leaseDetailListVisible = false;
              this.$message.success("物品归还成功。");
              this.querySearch();
            });
          });
        }
      });
    },
    returnTimeChange(value) {
      //归还日期变更 计算使用天数及应收租金
      this.leaseDetail.days = date.difference(
        this.leaseDetail.rentStartTime,
        value
      );
      this.leaseDetail.arRent = (
        this.leaseDetail.days * this.leaseDetail.rentDay
      ).toFixed(2);
      if (this.leaseDetail.arRent < 0) {
        this.leaseDetail.arRent = 0;
      }
      this.leaseDetail.returnAmount =
        this.leaseDetail.deposit +
        this.leaseDetail.rent -
        this.leaseDetail.arRent -
        this.leaseDetail.fine;
      this.$forceUpdate();
    },
    fineChange(value) {
      //罚款金额
      this.leaseDetail.returnAmount =
        this.leaseDetail.deposit +
        this.leaseDetail.rent -
        this.leaseDetail.arRent -
        this.leaseDetail.fine;
    },
    uploadOverrun: function () {
      this.$message({
        type: "error",
        message: "上传文件个数超出限制!最多上传5张图片!",
      });
    },
    handleGalleryUrl(response, file, fileList) {
      if (response.errno === 0) {
        this.leaseDetail.returnGoodsVoucher.push(response.data.fileUrl);
      }
      console.info(this.leaseDetail.returnGoodsVoucher);
      this.$refs["leaseDetail"].validateField("returnGoodsVoucher");
    },
    handleRemove: function (file, fileList) {
      for (var i = 0; i < this.leaseDetail.returnGoodsVoucher.length; i++) {
        // 这里存在两种情况
        // 1. 如果所删除图片是刚刚上传的图片，那么图片地址是file.response.data.url
        //    此时的file.url虽然存在，但是是本机地址，而不是远程地址。
        // 2. 如果所删除图片是后台返回的已有图片，那么图片地址是file.url
        var url;
        if (file.response === undefined) {
          url = file.url;
        } else {
          url = file.response.data.url;
        }

        if (this.leaseDetail.returnGoodsVoucher[i] === url) {
          this.leaseDetail.returnGoodsVoucher.splice(i, 1);
        }
      }
    },
  },
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}

.el-image {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}

.table-layout {
  margin-top: 5px;
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}

.table-cell {
  height: 70px;
  line-height: 20px;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 10px;
  font-size: 14px;
  color: #606266;
  text-align: center;
  white-space: pre-wrap;
  /* overflow: hidden; */
}

.table-cell-title {
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 10px;
  background: #f2f6fc;
  text-align: center;
  font-size: 14px;
  color: #303133;
}

.font-small {
  border-left: 3px solid #09afff;
  padding-left: 2px;
  color: #09afff;
  margin-top: 10px;
  margin-bottom: 5px;
}

.adv-img .el-upload--picture-card {
  width: 98px !important;
  height: 98px !important;
}

.adv-img .el-upload--picture-card {
  width: 180px;
  height: 118px;
}

.adv-img .el-upload-list--picture-card .el-upload-list__item {
  width: 180px;
  height: 118px;
}

.avatar-uploader .el-upload {
  width: 145px;
  height: 145px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.el-form-item__content {
  display: flex;
}

.marker {
  margin: 5px;
  font-size: 14px;
  font-weight: bold;
  background: #fff;
  color: #09afff;
  border-left: 3px solid #09afff;
  padding-left: 5px;
}
</style>
